import { ErrorResponse } from "../responses/ErrorResponse";
import { PostLoginRequestDevice } from "../requests/PostLoginRequest";
import { Response } from "@angular/http";

export class PostLoginNotAcceptableSession {

    public token: string;
    public last_seen_at: Date;
    public created_at: Date;
    public updated_at: Date;
    public device: PostLoginRequestDevice;

    public static createMany(data: any[]): PostLoginNotAcceptableSession[] {
        let sessions: PostLoginNotAcceptableSession[] = [];
        for (let item of data) {
            sessions.push(PostLoginNotAcceptableSession.createOne(item));
        }
        return sessions;
    }

    public static createOne(data: any): PostLoginNotAcceptableSession {
        let session = new PostLoginNotAcceptableSession();
        session.fill(data);
        return session;
    }

    public fill(data: any) {
        this.token = data.token || null;
        this.last_seen_at = data.last_seen_at ? new Date(data.last_seen_at) : null;
        this.created_at = data.created_at ? new Date(data.created_at) : null;
        this.updated_at = data.updated_at ? new Date(data.updated_at) : null;
        this.device = data.device || null;
    }

}


export class PostLoginNotAcceptableError {
    public sessions: PostLoginNotAcceptableSession[];

    constructor(error: Response) {
        let body = error.json();
        this.sessions = PostLoginNotAcceptableSession.createMany(body.sessions);
    }
}



// WEBPACK FOOTER //
// ./src/providers/api/errors/PostLoginNotAcceptableError.ts